 // 从 localStorage 获取当前的 compare 列表
 let compareList = localStorage.getItem('compare') ? JSON.parse(localStorage.getItem('compare')) : [];

 // 遍历所有复选框，检查是否在 compare 列表中
$('.collection-compare .compareCheckbox').each(function() {
    var compareId = $(this).attr('Compare-data-id');
    if (compareList.includes(compareId)) {
        $(this).prop('checked', true);
        $(this).parent().addClass('checked')
    }
});
if (compareList.length > 1) {
  $('nav#compare-nav').css('display', 'block');
  $('nav#compare-nav .selected-count').text(compareList.length + ' selected');
}
// 为 collection-compare 元素添加点击事件监听器
$('.collection-compare').on('click', function() {
    var $checkboxCompare = $(this).find('.compareCheckbox');
    var clickCompareId = $checkboxCompare.attr('Compare-data-id');
    if (clickCompareId) {
      if (!$checkboxCompare.is(':checked')) {
        // 如果复选框未选中，则选中它并将 Compare-data-id 添加到列表中
        $checkboxCompare.prop('checked', true);
        $checkboxCompare.parent().addClass('checked')
        compareList.push(clickCompareId);
        localStorage.setItem('compare', JSON.stringify(compareList));
      } else {
        // 如果复选框已选中，则取消选中它并从列表中删除 Compare-data-id
        $checkboxCompare.prop('checked', false);
        $checkboxCompare.parent().removeClass('checked')
        compareList = compareList.filter(id => id !== clickCompareId);
        localStorage.setItem('compare', JSON.stringify(compareList));
      }
      $('nav#compare-nav .selected-count').text(compareList.length+' selected')
      if (compareList.length > 1) {
        console.log('block:'+compareList.length)
        $('nav#compare-nav').css('display', 'block')
      }else{
        console.log('none:'+compareList.length)
        $('nav#compare-nav').css('display', 'none');
      }
    }
});
// 清空 localStorage 中的 compare 列表
function clearCompareList() {
  localStorage.removeItem('compare');
  compareList = [];
  $('.collection-compare .compareCheckbox').prop('checked', false).parent().removeClass('checked');
  $('nav#compare-nav').css('display', 'none');
}
$('nav#compare-nav .clear-all').on('click', function(){
  clearCompareList()
})